import { useContext } from "react";
import { useQuery } from "react-query";

import { getDeploymentContributors } from "@api";
import { OrgContext } from "@providers";

export const useContributors = () => {
  const { org } = useContext(OrgContext);

  return useQuery(
    ["contributors", { org }],
    () => getDeploymentContributors(org?.id!),
    {
      enabled: !!org,
      keepPreviousData: true,
    }
  );
};
